import { createAction } from 'redux-actions';

export const receiveSensors = createAction('Sensors/SENSORS_RECEIVED');
